import { UserQuizDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface Params {
  quizId?: string;
}

type Response = UserQuizDto[] | undefined;

interface Return {
  isGettingUserQuizzes: boolean;
  userQuizzes: Response;
  userQuizzesError: AxiosError | null;
}

export const useGetUserQuizzes = ({ quizId }: Params): Return => {
  const { restUserQuizApi } = useApiClient();
  const { user } = useUserContext();

  const { data, error, isLoading } = useQuery<Response, AxiosError>({
    enabled: !!(user?.userId && quizId),
    queryFn: async () => {
      if (user?.userId && quizId) {
        const response = await restUserQuizApi.getUserQuizzes(user.userId, quizId);

        return response.data;
      }
    },
    queryKey: [QueryKeyEnum.GET_USER_QUIZZES, user?.userId, quizId],
  });

  return {
    isGettingUserQuizzes: isLoading,
    userQuizzes: data,
    userQuizzesError: error,
  };
};
